"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATETIME_HUGE_WITH_SECONDS = exports.DATETIME_HUGE = exports.DATETIME_FULL_WITH_SECONDS = exports.DATETIME_FULL = exports.DATETIME_MED_WITH_WEEKDAY = exports.DATETIME_MED_WITH_SECONDS = exports.DATETIME_MED = exports.DATETIME_SHORT_WITH_SECONDS = exports.DATETIME_SHORT_WITH_TZ = exports.DATETIME_SHORT = exports.TIME_WITH_LONG_OFFSET = exports.TIME_WITH_SHORT_OFFSET = exports.TIME_WITH_SECONDS = exports.TIME_SIMPLE = void 0;
const n = 'numeric', s = 'short', l = 'long';
const hourCycle = 'h23'; // Military time
exports.TIME_SIMPLE = {
    hour: n,
    minute: n,
    hourCycle,
};
exports.TIME_WITH_SECONDS = {
    hour: n,
    minute: n,
    second: n,
    hourCycle,
};
exports.TIME_WITH_SHORT_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    timeZoneName: s,
    hourCycle,
};
exports.TIME_WITH_LONG_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    timeZoneName: l,
    hourCycle,
};
exports.DATETIME_SHORT = {
    year: n,
    month: n,
    day: n,
    hour: n,
    minute: n,
    hourCycle,
};
exports.DATETIME_SHORT_WITH_TZ = {
    year: n,
    month: n,
    day: n,
    hour: n,
    minute: n,
    timeZoneName: s,
    hourCycle,
};
exports.DATETIME_SHORT_WITH_SECONDS = {
    year: n,
    month: n,
    day: n,
    hour: n,
    minute: n,
    second: n,
    hourCycle,
};
exports.DATETIME_MED = {
    year: n,
    month: s,
    day: n,
    hour: n,
    minute: n,
    hourCycle,
};
exports.DATETIME_MED_WITH_SECONDS = {
    year: n,
    month: s,
    day: n,
    hour: n,
    minute: n,
    second: n,
    hourCycle,
};
exports.DATETIME_MED_WITH_WEEKDAY = {
    year: n,
    month: s,
    day: n,
    weekday: s,
    hour: n,
    minute: n,
    hourCycle,
};
exports.DATETIME_FULL = {
    year: n,
    month: l,
    day: n,
    hour: n,
    minute: n,
    timeZoneName: s,
    hourCycle,
};
exports.DATETIME_FULL_WITH_SECONDS = {
    year: n,
    month: l,
    day: n,
    hour: n,
    minute: n,
    second: n,
    timeZoneName: s,
    hourCycle,
};
exports.DATETIME_HUGE = {
    year: n,
    month: l,
    day: n,
    weekday: l,
    hour: n,
    minute: n,
    timeZoneName: l,
    hourCycle,
};
exports.DATETIME_HUGE_WITH_SECONDS = {
    year: n,
    month: l,
    day: n,
    weekday: l,
    hour: n,
    minute: n,
    second: n,
    timeZoneName: l,
    hourCycle,
};
//# sourceMappingURL=humla-date-time.js.map